import { dateToAbsoluteTitle, fmtRelative } from "@/lib/format";
import { cn } from "@/lib/utils";

export function RelTime({ value, className, mono = false }: { value: number | string | Date | null | undefined; className?: string; mono?: boolean }) {
  return (
    <span title={dateToAbsoluteTitle(value)} className={cn(mono && "font-mono text-xs", className)}>
      {fmtRelative(value)}
    </span>
  );
}
